<template>
      <div class="foot" >
       	<div class="explain">
       	  <div class="foottitle">
            {{ $t('foot.title') }}
       	  </div>
          <!-- 段落分情况显示, 奇奇怪怪的需求均出自PM -->
       	  <div v-if="showParagraph"  class="footcontent" v-html="$t('foot.p1')"></div>
       	  <div class="footcontent" v-html="$t('foot.p2')"></div>
       	</div>
       	<div class="policy">
          <p>{{ $t('foot.copyright') }}</p>
          <p v-if="isGlobal"> <a href="https://www.centurygames.com/terms-of-service/">Terms of service</a> | <a href="https://www.centurygames.com/privacy-policy/">Privacy Policy</a> | <a href="https://www.centurygames.com/impressum/">Impressum</a></p>
          <template v-else>
            <p style="margin-bottom: 10px;">
            <a href="https://www.centurygames.com/zh/terms-of-service/">服务条款</a>
            |
            <a href="https://www.centurygames.com/zh/privacy-policy/">隐私政策</a>
            |
            <a href="https://www.centurygames.com/impressum/">Impressum</a>
          </p>
          <p>网络文化经营许可证：京网文 [2018] 11352-1040 号<br> 京ICP备13035911号-2</p>
          </template>
        </div>
    </div>
</template>

<script>
  import { mapGetters} from 'vuex'

  export default {
    props: ['showParagraph'],
    data() {
       return {

       }
    },
    computed: {
      ...mapGetters([
        'isGlobal'
      ]),
    },
  }
</script>

<style scoped>
  .foot{
    width: 100%;
    margin-top: 1.25rem;
    overflow: hidden;
  }
  .explain{
    background-color: #293549;
    padding-bottom: 0.9375rem;
  }
  .explain .footcontent{
    padding:0 0.9375rem;
    color: #a9adb0;
    font-size: 0.82rem;
    line-height: 1.1rem;
    margin-bottom: 0.9375rem;
  }
  .foottitle{
    font-size: 1.3rem;
    padding-left: 0.9375rem;
    line-height: 2.5rem;
    font-weight: 500;
    color: #FFFFFF;
    font-family: "SemiBold";
  }
  .policy{
    color: #FFFFFF;
    padding: 0.625rem 0;
    font-size: 0.75rem;
    line-height: 1.125rem;
    text-align: center;
  }
  .policy a{
    color: #FFFFFF;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/foot.vue